import { FC } from 'react';

import { Text, VSpacing } from '@hh.ru/magritte-ui';

interface RequisitesFormTitleProps {
    title: string;
    subtitle: string;
}

export const RequisitesFormTitle: FC<RequisitesFormTitleProps> = ({ title, subtitle }) => {
    return (
        <div>
            <Text typography="title-4-semibold">{title}</Text>
            <VSpacing default={4} />
            <Text typography="paragraph-2-regular">{subtitle}</Text>
            <VSpacing default={24} />
        </div>
    );
};
